
// export default OTPVerification;
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios'; // Import axios for API requests
import logo from './assets/logo-footer.png';
import { useLanguage } from "./store/language-context";
import { useTranslation } from "react-i18next";

const OTPVerification = () => {
  const { URL } = useLanguage();
  const { t } = useTranslation();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(""); // To show any error from the backend

  const location = useLocation();
  const { contact, contact_type } = location.state || {};

  const navigate = useNavigate();

  // Handle OTP input change
  const handleChange = (index, value) => {
    if (isNaN(value)) return; // Only allow numeric values
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto-focus on the next input field when the current one is filled
    if (value && index < otp.length - 1) {
      // Move focus to the next input element
      document.getElementById(`otp-${index + 1}`).focus();
    }
    // If the current input is empty and it's not the first input, focus the previous input
    else if (!value && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };


  // Handle OTP form submission
  const handleSubmit = async () => {
    const otpValue = otp.join(""); // Join the OTP array to form a single string
    if (!otpValue || otpValue.length < 6) {
      setError(t('otp.err-1'));
      return;
    }

    try {
      // Sending the OTP and contact to the backend
      const response = await axios.post(`${URL}/verify-otp`, {
        contact: contact,
        otp: otpValue,
      });

      if (response.status === 200) {
        setMessage(t('otp.done'));
        setTimeout(() => {

          navigate('/reset-password', {
            state: { contact, contact_type }
          });
        }, 2000);
      } else {
        setError(t('otp.failed'));
      }
    } catch (error) {
      setError(t('custom.err'));
    }

  };

  return (
    <div className="login-section">
      <div className="login row justify-content-between">
        <div className="right-section logoimg col-lg-7 col-md-6">
          <Link to='/' className='image-part'>
            <img src={logo} className='img-fluid w-100' alt="Logo" />
          </Link>
        </div>

        <div className="form-part col-lg-5 col-md-6">
          <div className="container">
            <div className="otp-code" dir="ltr">
              <p>{t('hello')}</p>
              <h6>{t('routes.otp')}</h6>
              <p className="col-12 text-end m-0" style={{ color: '#929292', fontSize: '16px' }}>
                {t('otp.sent-to')} {contact_type === 'email' ? t('contact.email') : t('contact.phone')} <strong>{contact}</strong>
              </p>

              <div className="row justify-content-around">
                {otp.map((value, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="text"
                    maxLength="1"
                    value={value}
                    onChange={(e) => handleChange(index, e.target.value)}
                    className="col-2 text-center otp-input"

                  />
                ))}
              </div>

              {message && <p className="text-green-500 text-sm mt-2">{message}</p>}
              {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

              {/* <button onClick={handleResend} className="text-blue-500 text-sm mt-2">
                إعادة إرسال الكود
              </button> */}

              <button onClick={handleSubmit} className="bg-red-700 text-white px-4 py-2 rounded-md w-full mt-4 hover:bg-red-800">
                {t('custom.send')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTPVerification;
